import { createSlice } from '@reduxjs/toolkit';
import { calculateMasterAllocation, createBulkUpload, createGatepass, createMasterAllocation, downlaodOutwards, downloadAllocationSummary, downloadBulkUploadSample, getMasterAllocationTasks, getOutwardStyles, getOutwardSummary, getPendingStoreInwards, getStyles, getSummary, rejectAllocationTasks, removeShortlistedProducts, removeShortlistedStyles, shortlistOutwardStyles, shortlistStyles, submitOutwardStyles, submitStyles } from './api';

export const AllocationDashboardSlice = createSlice({

    name: 'allocationDashboard',
    initialState: {
        loading: false,
        error: '',
        data: [],
        calculateData: {},
        outwardData: {},
        approveStylesData: {},
        outwardSummaryData: {},
        approveSummaryData: {},
        pendingStoreInwardData: {},
        submitOutwardSuccessMessage: '',
        shortlistOutwardSuccessMessage: '',
        removeShortlistedProductsSuccessMessage: '',
        removeShortlistedStylesSuccessMessage: '',
        shortlistStylesSuccessMessage: '',
        submitStylesSuccessMessage: '',
        createMasterAllocationSuccessMessage: '',
        rejectAllocationTaskSuccessMessage: '',
        createGatepassSuccessMessage: '',
        createBulkUploadSuccessMessage: '',
        shortlistStylesFailedMessage: ''
    },
    reducers: {
        clearError: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
        clear: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getMasterAllocationTasks.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getMasterAllocationTasks.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload.data
        })
        builder.addCase(getMasterAllocationTasks.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })

        builder.addCase(calculateMasterAllocation.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(calculateMasterAllocation.fulfilled, (state, action) => {
            state.loading = false;
            state.calculateData = action.payload.data
        })
        builder.addCase(calculateMasterAllocation.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })

        builder.addCase(createMasterAllocation.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(createMasterAllocation.fulfilled, (state, action) => {
            state.loading = false;
            state.createMasterAllocationSuccessMessage = action.payload.data.message
        })
        builder.addCase(createMasterAllocation.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })

        builder.addCase(getOutwardStyles.pending, (state, action) => {
            state.loading = true;
            state.outwardData = [];
        })
        builder.addCase(getOutwardStyles.fulfilled, (state, action) => {
            state.loading = false;
            state.outwardData = action.payload.data;
        })
        builder.addCase(getOutwardStyles.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })

        builder.addCase(submitOutwardStyles.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(submitOutwardStyles.fulfilled, (state, action) => {
            state.loading = false;
            state.submitOutwardSuccessMessage = action.payload.data.message
        })
        builder.addCase(submitOutwardStyles.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })

        builder.addCase(shortlistOutwardStyles.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(shortlistOutwardStyles.fulfilled, (state, action) => {
            state.loading = false;
            state.shortlistOutwardSuccessMessage = action.payload.data.message
        })
        builder.addCase(shortlistOutwardStyles.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(removeShortlistedProducts.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(removeShortlistedProducts.fulfilled, (state, action) => {
            state.loading = false;
            state.removeShortlistedProductsSuccessMessage = action.payload.data.message
        })
        builder.addCase(removeShortlistedProducts.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(rejectAllocationTasks.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(rejectAllocationTasks.fulfilled, (state, action) => {
            state.loading = false;
            state.rejectAllocationTaskSuccessMessage = action.payload.data.message
        })
        builder.addCase(rejectAllocationTasks.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(getOutwardSummary.pending, (state, action) => {
            state.loading = true;
            state.outwardSummaryData = {}
        })
        builder.addCase(getOutwardSummary.fulfilled, (state, action) => {
            state.loading = false;
            state.outwardSummaryData = action.payload.data
        })
        builder.addCase(getOutwardSummary.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(getPendingStoreInwards.pending, (state, action) => {
            state.loading = true;
            state.pendingStoreInwardData = {}
        })
        builder.addCase(getPendingStoreInwards.fulfilled, (state, action) => {
            state.loading = false;
            state.pendingStoreInwardData = action.payload.data
        })
        builder.addCase(getPendingStoreInwards.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(getStyles.pending, (state, action) => {
            state.loading = true;
            state.approveStylesData = {}
        })
        builder.addCase(getStyles.fulfilled, (state, action) => {
            state.loading = false;
            state.approveStylesData = action.payload.data
        })
        builder.addCase(getStyles.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(shortlistStyles.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(shortlistStyles.fulfilled, (state, action) => {
            state.loading = false;
            state.shortlistStylesSuccessMessage = action.payload.data.message
            state.shortlistStylesFailedMessage = action.payload.data.failed
        })
        builder.addCase(shortlistStyles.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(submitStyles.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(submitStyles.fulfilled, (state, action) => {
            state.loading = false;
            state.submitStylesSuccessMessage = action.payload.data.message
        })
        builder.addCase(submitStyles.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(removeShortlistedStyles.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(removeShortlistedStyles.fulfilled, (state, action) => {
            state.loading = false;
            state.removeShortlistedStylesSuccessMessage = action.payload.data.message
        })
        builder.addCase(removeShortlistedStyles.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        
        builder.addCase(createGatepass.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(createGatepass.fulfilled, (state, action) => {
            state.loading = false;
            state.createGatepassSuccessMessage = action.payload.data.message
        })
        builder.addCase(createGatepass.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })

        builder.addCase(getSummary.pending, (state, action) => {
            state.loading = true;
            state.approveSummaryData = {}
        })
        builder.addCase(getSummary.fulfilled, (state, action) => {
            state.loading = false;
            state.approveSummaryData = action.payload.data
        })
        builder.addCase(getSummary.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })

        builder.addCase(createBulkUpload.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(createBulkUpload.fulfilled, (state, action) => {
            state.loading = false;
            state.createBulkUploadSuccessMessage = action.payload.data.message
        })
        builder.addCase(createBulkUpload.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(downlaodOutwards.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(downloadBulkUploadSample.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(downloadAllocationSummary.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        
    }
})

export const { clearError, clear } = AllocationDashboardSlice.actions

export default AllocationDashboardSlice.reducer